'use client';

import React from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';
import categoriesData from '../../utils/categories.json';
import styles from './ProductListing.module.css';

interface Category {
  Slug: string;
  Name: string;
  Icon: string;
  Color?: string;
}

const categories = categoriesData as Category[];
const duplicatedCategories = [...categories, ...categories];

export const CategorySlider: React.FC = () => {
  const tCat = useTranslations('categories');
  const { localizeFullPath } = useLocalizedPath();

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.sliderTrack}>
        {duplicatedCategories.map((category, index) => {
          const translatedName = tCat(`${category.Slug}.name`);
          return (
            <Link
              key={`${category.Slug}-${index}`}
              href={localizeFullPath(`/giftcards/${category.Slug}`)}
              prefetch={false}
              className={styles.categoryChip}
            >
              <span className={styles.categoryChipIcon}>{category.Icon}</span>
              {translatedName}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
